import { Component, OnInit } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Globals } from 'src/app/globals';
import { TranslateService } from '@ngx-translate/core';
import { UserService } from 'src/app/service/user.service';
import { RoleService } from 'src/app/service/role.service';
import { OrgService } from 'src/app/service/org.service';
import { CoursesService } from 'src/app/service/courses.service';
import { AcademicsService } from 'src/app/service/academics.service';
import { ScoresService } from 'src/app/service/scores.service';
import { DatePipe } from '@angular/common'
@Component({
  selector: 'app-letter-create',
  templateUrl: './letter-create.component.html',
  styleUrls: ['./letter-create.component.scss']
})
export class LetterCreateComponent implements OnInit {
  showLoader: boolean = false;
  creating: boolean = false;
  highlightColors: any = [];

  letterTypeCreate = new FormGroup({
    wtypeNameAr: new FormControl('', [
      Validators.required,
    ]),
    wtypeNameEn: new FormControl('', [
      Validators.required,
    ])

  });

  constructor(
    // private userService: UserService,
    //  private ispService: IspService,
    private toastrService: ToastrService
    // , private roleService: RoleService
    , public globals: Globals, private toastr: ToastrService, private activatedRoute: ActivatedRoute, private router: Router
    , public translate: TranslateService
    , private academicsService: AcademicsService
    , private roleService: RoleService
    , private orgService: OrgService
    , private datePipe: DatePipe
    , private scoresService: ScoresService
  ) {

  }

  ngOnInit(): void {
  }

  letterTypeCreateChange() {
    // let classHours = this.createType.controls.classHours.value;
    // let clinicalHours = this.createType.controls.clinicalHours.value;
    // this.createType.controls.totalHours.setValue(Number(classHours) + Number(clinicalHours));
  }

  letterTypeCreateSubmit() {
    if (this.letterTypeCreate.valid) {
      console.log(this.letterTypeCreate.value);
      // call your service 
      //  let code = this.createCorseCategory.controls.code.value;
      //  let nameAr = this.createCorseCategory.controls.nameAr.value;
      //  let nameEn = this.createCorseCategory.controls.nameEn.value;
      //  let workingDay = this.createCorseCategory.controls.workingDay.value;
      //  let timeFrom = this.datePipe.transform(new Date().toLocaleDateString("zh-Hans-CN", { year: 'numeric', month: '2-digit', day: '2-digit' }) + " " + this.createType.controls.timeFrom.value, "yyyy-MM-dd'T'HH:mm:ss.SSS");
      //  let timeTo = this.datePipe.transform(new Date().toLocaleDateString("zh-Hans-CN", { year: 'numeric', month: '2-digit', day: '2-digit' }) + " " + this.createType.controls.timeTo.value, "yyyy-MM-dd'T'HH:mm:ss.SSS");
      this.addLetterType(this.letterTypeCreate.value)
    }
    else {
      this.letterTypeCreate.markAllAsTouched();
      this.letterTypeCreate.markAsDirty();
    }
  }

  addLetterType(letterTypeObj: any) {
    this.creating = true;
    let username = this.globals.currentUserInfo.username;
    this.scoresService.addWLetterType(username, 10, letterTypeObj)
      .subscribe(
        data => {
          console.log(data);
          if (data.sts == "SUCCESS") {
            if (this.globals.lang == "ar") {
              this.toastrService.success(data.arMsg);
            } else {
              this.toastrService.success(data.enMsg);
            }
            this.creating = false;
            this.router.navigate(['/scores-grades/warning-letters-type']);
          } else {
            if (this.globals.lang == "ar") {
              this.toastrService.error(data.arMsg);
            } else {
              this.toastrService.error(data.enMsg);
            }
            this.creating = false;
            //this.router.navigate(['/academics/calender-day-type']);
          }
        },
        error => {
          this.creating = false;
          this.toastrService.error(this.translate.instant('FAIL_TO_CREATE'));
        }
      );
  }
  onItemSelect(item: any) {
    // console.log('onItemSelect', item);
  }

  changeactive() {

  }

}



